import { Response } from '@marketplace-web/shared/api-client'

import { BusinessAccountsTermsOfUseResp } from 'types/api/response/business-accounts-terms-of-use-resp'

import { transformBusinessAccountsTermsOfUseDto } from 'data/transformers/business-account'

export const transformBusinessAccountsTermsOfUseResponse = (
  response: Response<BusinessAccountsTermsOfUseResp>,
) => transformBusinessAccountsTermsOfUseDto(response)
